module.exports = __webpack_public_path__ + "img/funnel.a310862a.svg";